<script setup lang="ts">
const page = useRouteParams<string | null>('page', null)

const { LocalConfigurationStore } = stores()
const info = computed(() =>
  LocalConfigurationStore.value?.aboutPages?.find((p) => p.code === page.value)
)

if (!info.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Página no encontrada',
  })
}
</script>

<template>
  <LayoutContainer class="py-6 lg:py-14">
    <div class="mb-4 flex">
      <PvDivider />
      <div class="px-4">
        <TitleComponent
          v-if="info?.title"
          :text="info.title"
          type="subtitle"
          no-wrap
        />
      </div>
      <PvDivider />
    </div>
    <CardComponent v-if="info?.content">
      <div class="flex flex-col gap-8 p-6 lg:p-14">
        <template
          v-for="(item, i) in info?.content"
          :key="i"
        >
          <div>
            <div class="text-xl font-bold">{{ item.section }}</div>
            <p class="hyphens-auto text-justify text-sm leading-[1.2rem]">
              {{ item.body }}
            </p>
          </div>
        </template>
      </div>
    </CardComponent>
    <template v-if="info?.annexesSrc?.length">
      <div
        v-for="annex in info.annexesSrc"
        :key="annex"
        class="sm:my-3 lg:my-5 rounded-xl overflow-hidden"
      >
        <ImageComponent
          :src="annex"
          class="w-full"
        />
      </div>
    </template>
  </LayoutContainer>
</template>
